import React from 'react';

interface SectionLayoutProps {
  children: React.ReactNode;
  id?: string;
  note?: string;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
  sectionId?: string;
  subtitles?: string[];
  title: string;
}

const SectionLayout = ({
  children,
  id,
  note,
  leftElement,
  rightElement,
  sectionId,
  subtitles,
  title,
}: SectionLayoutProps) => (
  <section id={sectionId} className="mt-28 border-0 border-t border-solid border-black pt-28">
    <div id={id} className="flex flex-col">
      <h1 className="m-0 font-suisse-works text-headline-xxs text-black">{title}</h1>
      {subtitles?.length > 0 && (
        <div className="mt-8">
          {subtitles.map((subtitle, index) => (
            <p key={index} className="m-0 font-suisse-intl text-overline-md text-black">
              {subtitle}
            </p>
          ))}
        </div>
      )}
      {note && (
        <p className="mb-0 mt-8 font-suisse-intl text-body-sm font-light text-black">{note}</p>
      )}
      {(leftElement || rightElement) && (
        <div className="mt-16 flex flex-col gap-28 sm:mt-28 sm:flex-row sm:justify-between sm:gap-0">
          {leftElement}
          {rightElement}
        </div>
      )}
    </div>
    {children}
  </section>
);

export default SectionLayout;
